export const TABLE_SKIP_INDEX = '-1';
